import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.learningGoals.label': {
    id: 'profile.learningGoals.label',
    defaultMessage: 'What value do you want to get from studying at Prometheus PLUS?',
    description: 'The label for learning goals in a user profile.',
  },
  'profile.learningGoals.empty': {
    id: 'profile.learningGoals.empty',
    defaultMessage: 'Add the value you want to get from studying at Prometheus PLUS',
    description: "The affordance to add learning goals to a user's profile.",
  },
  'profile.learningGoals.option.default': {
    id: 'profile.learningGoals.option.default',
    defaultMessage: 'Select a value',
  },
  'profile.learningGoals.placeholder': {
    id: 'profile.learningGoals.placeholder',
    defaultMessage:
      'Prometheus PLUS is an in-depth training program with mentor support (paid format)',
  },
});

export default messages;
